import React, { useState, useEffect, useCallback } from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";

export default function ConsultaOrcamentoForm() {
  const [numeroOrcamento, setNumeroOrcamento] = useState("");
  const [nomeConsulta, setNomeConsulta] = useState("");
  const [emailConsulta, setEmailConsulta] = useState("");
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();

  const validar = useCallback(() => {
    const e = {};
    if (!numeroOrcamento.trim()) e.numeroOrcamento = "Número é obrigatório.";
    if (!nomeConsulta.trim()) e.nomeConsulta = "Nome é obrigatório.";
    if (!emailConsulta.trim()) e.emailConsulta = "E-mail é obrigatório.";
    return e;
  }, [numeroOrcamento, nomeConsulta, emailConsulta]);

  useEffect(() => {
    setErrors(validar());
  }, [validar]);

  const handleSubmit = (e) => {
    e.preventDefault();
    const e2 = validar();
    setErrors(e2);
    if (Object.keys(e2).length > 0) return;

    navigate(`/orcamento/${encodeURIComponent(numeroOrcamento)}?email=${encodeURIComponent(emailConsulta)}`);
  };

  return (
    <motion.div 
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      viewport={{ once: true }}
      className="w-full min-w-0"
    >
      <motion.h2
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ duration: 0.6 }}
        viewport={{ once: true }}
        className="text-xl xs:text-2xl xs2:text-2xl xs3:text-3xl sm:text-3xl 
                   md:text-4xl font-bold mb-4 xs:mb-5 sm:mb-6 text-center 
                   text-secondary-600"
      >
        Consulte seu Orçamento
      </motion.h2>
      <form onSubmit={handleSubmit} className="w-full max-w-xl mx-auto 
                                              space-y-4 xs:space-y-5 sm:space-y-6">
        <div>
          <label htmlFor="numeroOrcamento" className="block text-xs xs:text-sm sm:text-base 
                                                     font-semibold text-gray-700 mb-1 xs:mb-2">
            Número do Orçamento <span className="text-red-500">*</span>
          </label>
          <input
            type="text"
            id="numeroOrcamento"
            value={numeroOrcamento}
            onChange={(e) => setNumeroOrcamento(e.target.value)}
            className={`input-modern ${
              errors.numeroOrcamento 
                ? "border-red-500 focus:border-red-500 focus:ring-red-200" 
                : ""
            }`}
            placeholder="Digite o número do orçamento"
            aria-invalid={!!errors.numeroOrcamento}
            aria-describedby={errors.numeroOrcamento ? 'numero-error' : undefined}
          />
          {errors.numeroOrcamento && (
            <p 
              id="numero-error" 
              className="text-red-600 text-xs xs:text-sm mt-1 flex items-center gap-1"
              role="alert"
            >
              <span>⚠️</span> {errors.numeroOrcamento}
            </p>
          )}
        </div>
        <div>
          <label htmlFor="nomeConsulta" className="block text-xs xs:text-sm sm:text-base 
                                                  font-semibold text-gray-700 mb-1 xs:mb-2">
            Nome <span className="text-red-500">*</span>
          </label>
          <input
            type="text"
            id="nomeConsulta"
            value={nomeConsulta}
            onChange={(e) => setNomeConsulta(e.target.value)}
            className={`input-modern ${
              errors.nomeConsulta 
                ? "border-red-500 focus:border-red-500 focus:ring-red-200" 
                : ""
            }`}
            placeholder="Digite seu nome"
            aria-invalid={!!errors.nomeConsulta}
            aria-describedby={errors.nomeConsulta ? 'nome-error' : undefined}
          />
          {errors.nomeConsulta && (
            <p 
              id="nome-error" 
              className="text-red-600 text-xs xs:text-sm mt-1 flex items-center gap-1"
              role="alert"
            >
              <span>⚠️</span> {errors.nomeConsulta}
            </p>
          )}
        </div>
        <div>
          <label htmlFor="emailConsulta" className="block text-xs xs:text-sm sm:text-base 
                                                    font-semibold text-gray-700 mb-1 xs:mb-2">
            Seu e-mail <span className="text-red-500">*</span>
          </label>
          <input
            type="email"
            id="emailConsulta"
            value={emailConsulta}
            onChange={(e) => setEmailConsulta(e.target.value)}
            className={`input-modern ${
              errors.emailConsulta 
                ? "border-red-500 focus:border-red-500 focus:ring-red-200" 
                : ""
            }`}
            placeholder="seu@email.com"
            aria-invalid={!!errors.emailConsulta}
            aria-describedby={errors.emailConsulta ? 'email-error' : undefined}
          />
          {errors.emailConsulta && (
            <p 
              id="email-error" 
              className="text-red-600 text-xs xs:text-sm mt-1 flex items-center gap-1"
              role="alert"
            >
              <span>⚠️</span> {errors.emailConsulta}
            </p>
          )}
        </div>
        <button
          type="submit"
          className="w-full bg-gradient-to-r from-secondary-600 to-secondary-700 
                   hover:from-secondary-700 hover:to-secondary-800 text-white 
                   font-semibold py-2.5 xs:py-3 sm:py-3.5 px-4 xs:px-5 sm:px-6 
                   rounded-lg text-sm xs:text-base sm:text-lg transition-all duration-200 
                   shadow-medium hover:shadow-large hover:scale-105 active:scale-100
                   focus:outline-none focus:ring-2 focus:ring-secondary-500 focus:ring-offset-2"
        >
          Consultar
        </button>
      </form>
    </motion.div>
  );
}
